<template>
  <modal :showing="show" :large="false">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ $t("accounting.modal.conge.title") }}</h6>
      <div class="closeFeature" @click="closeModal"></div>
    </d-card-header>
    <d-card-body>
      <d-form>
        <div v-if="mode === null">
          <div class="form-group d-flex flex-column">
            <p>
              {{ $t("accounting.modal.choice") }}
              <span v-if="appliedToAll">{{
                $t("accounting.modal.to.all.salary")
              }}</span
              ><span v-else>{{ $t("accounting.modal.to.selection") }}</span>
            </p>
            <div
              aria-label="Button group"
              class="btn-group-undefined btn-group"
            >
              <button class="btn btn-success" @click="mode = 'INCREMENT'">
                <i class="fa fa-plus mr-1"></i> Ajouter des jours
              </button>
              <button class="btn btn-danger" @click="mode = 'DEDUCTION'">
                <i class="fa fa-minus mr-1"></i> Deduire des jours
              </button>
              <button class="btn btn-primary" @click="mode = 'UPDATE'">
                <i class="fa fa-edit mr-1"></i> Nouveau solde
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <p v-if="mode === 'DEDUCTION'">
            {{ $t("accounting.modal.conge.remove") }}
            <span v-if="appliedToAll">{{
              $t("accounting.modal.to.all.salary")
            }}</span
            ><span v-else>{{ $t("accounting.modal.to.selection") }}</span>
          </p>
          <p v-if="mode === 'INCREMENT'">
            {{ $t("accounting.modal.conge.add") }}
            <span v-if="appliedToAll">{{
              $t("accounting.modal.to.all.salary")
            }}</span
            ><span v-else>{{ $t("accounting.modal.to.selection") }}</span>
          </p>
          <p v-if="mode === 'UPDATE'">
            {{ $t("accounting.modal.conge.update") }}
            <span v-if="appliedToAll">{{
              $t("accounting.modal.to.all.salary")
            }}</span
            ><span v-else>{{ $t("accounting.modal.to.selection") }}</span>
          </p>
        </div>
        <div class="form-group">
          <label for="days">{{ $t("accounting.modal.input") }} </label><br />
          <input
            class="form-control"
            type="number"
            id="days"
            v-model="days"
            name="days"
            step="0.08"
            min="0"
            @input="checkDays"
            :disabled="mode === null"
          />
          <div class="invalid-feedback d-block" v-if="error">
            {{ $t("accounting.modal.error") }}
          </div>
        </div>
      </d-form>
    </d-card-body>

    <d-card-footer>
      <div class="d-flex justify-content-between">
        <button class="btn btn-danger" @click="closeModal">
          {{ $t("global.return") }}
        </button>
        <button
          class="btn btn-success"
          @click="sendSolde"
          :disabled="mode === null"
        >
          {{ $t("global.save") }}
        </button>
      </div>
    </d-card-footer>
  </modal>
</template>

<script>
import Modal from '../../layout/Modal/Modal';

export default {
  name: 'soldeConge',
  components: { Modal },
  data() {
    return {
      show: false,
      days: 0,
      error: false,
      mode: null,
      appliedToAll: false,
    };
  },
  methods: {
    checkDays() {
      this.error = false;
      
      if (this.days%0.08>0.1) {
        this.error = true;
      }
    },
    closeModal() {
      this.days = 0;
      this.mode = null;
      this.error = false;
      this.show = false;
    },
    openModal(appliedToAll) {
      this.show = true;
      this.mode = null;
      this.error = false;
      this.appliedToAll = appliedToAll;
    },
    sendSolde() {
      this.checkDays();
      if (this.days === 0) {
        this.error = true;
      } else if (this.error === false) {
        this.$emit('updateLeftVacations', { days: this.days, mode: this.mode });
        this.closeModal();
      }
    },
  },
};
</script>

<style scoped>
</style>
